import { render } from "./Anchor.vue?vue&type=template&id=48139766"
import script from "./Anchor.vue?vue&type=script&lang=js"
export * from "./Anchor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/common/Anchor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48139766"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48139766', __exports__)) {
    api.reload('48139766', __exports__)
  }
  
  module.hot.accept("./Anchor.vue?vue&type=template&id=48139766", () => {
    api.rerender('48139766', render)
  })

}


export default __exports__